import React from "react"
import {useSuggestedSolutions} from "../Hooks/SuggestedSolutions"
import {Modal} from "../Components/Modal"
import {ViewImpressions} from "./SolutionSuggestions/ViewImpressions"
import {ViewLoading} from "./SolutionSuggestions/ViewLoading"
import {MODAL__SOLUTION_SUGGESTIONS} from "../Hooks/Modal"
import style from "./SolutionSuggestions.css"

export const SolutionSuggestions = () => {
    const suggestedSolutions = useSuggestedSolutions()
    return <Modal type={MODAL__SOLUTION_SUGGESTIONS} userStyle={{width: "900px"}} bright={true}>
        <div className={style.layout}>
            {suggestedSolutions.isStepImpressions() && <ViewImpressions suggestedSolutions={suggestedSolutions}/>}
            {suggestedSolutions.isStepLoading() && <ViewLoading suggestedSolutions={suggestedSolutions}/>}
        </div>
    </Modal>
}
